import { IPaginationDTO, IUserDTO } from '@/dtos';

import { getPossibleUsersAPI, updateTeamLeadAPI } from '@/services/admin';

export const getPossibleUsers = async (
  body: IPaginationDTO,
): Promise<{ data: IUserDTO[]; count: number }> => {
  try {
    const response = await getPossibleUsersAPI(body);
    return response;
  } catch {
    throw 'Cannot get Users';
  }
};

export const updateTeamLead = async (
  teamId: string,
  yearId: string,
  userId: string,
  updateTeam: boolean,
): Promise<IUserDTO> => {
  try {
    const leader = await updateTeamLeadAPI(teamId, yearId, userId, updateTeam);
    return leader;
  } catch {
    throw "Can't update team leader";
  }
};
